export type AspectPolicy = {
  preferredAspect: number | ((data?: Record<string, unknown>[]) => number);
  minAspect: number; // narrower than this → distorted
  maxAspect: number; // wider than this → distorted
  minHeight: number;
  maxHeight: number;
};

export const useAspectStyle = (policy: AspectPolicy, data?: Record<string, unknown>[]): React.CSSProperties => {
  return {
    aspectRatio: typeof policy.preferredAspect === 'function' ? policy.preferredAspect(data) : policy.preferredAspect,
    minHeight: `${policy.minHeight}px`,
    maxHeight: `${policy.maxHeight}px`,
    maxWidth: `calc(${policy.maxAspect} * ${policy.minHeight}px * 3)`, // cap absurd widths
  };
};
